import React, { createContext, useState, useContext } from 'react';

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
  const [selectedDomain, setSelectedDomain] = useState(null);

  return (
    <DomainContext.Provider value={{ selectedDomain, setSelectedDomain }}>
      {children}
    </DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);
